import React from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Typography, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import AuthButtonComponent from "../../../components/AuthButtonCompnent";
import AuthSelectLanguageComponent from "../../../components/AuthSelectLanguageComponent";
import logo from "../../../assets/icons/twizz-logo-white.svg";
import SuccessIcon from "../../../assets/icons/green-icon.svg";
import "./index.less";

const { Content } = Layout;
const { Text } = Typography;

const ConfirmPasswordChangedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout className="password-confirm-page gradient-background">
      <Content className="password-confirm-content">
        <Row justify="center" className="logo-row">
          <img src={logo} className="logo" alt="logo" onClick={() => navigate("/")} />
        </Row>

        <Row justify="center" className="title-row">
          <Text className="title">{t("auth-forgot-password-confirm-title")}</Text>
        </Row>

        <Row justify="center" className="icon-row">
          <img src={SuccessIcon} className="success-icon" alt="Success" />
        </Row>

        <Row justify="center" className="text-row">
          <Text className="description">{t("auth-forgot-password-confirm-text")}</Text>
        </Row>

        <Row justify="center" className="button-row">
          <AuthButtonComponent label={t("auth-signIn-button")} onClick={() => navigate("/")} />
        </Row>

        <Row justify="center" className="language-selector-row">
          <AuthSelectLanguageComponent />
        </Row>
      </Content>
    </Layout>
  );
};

export default ConfirmPasswordChangedPage;
